import {cancelOrder, clinicSqbOrderPay, clinicSqbQueryResult, getDicts, getMedicalOrderDetail} from "@/api";
import baseConfig from "@/api/config";
import {message} from "@/assets/utils/common";
import {getSignDoctorName, updateMedicineUsageSign} from "@/assets/utils/medicineUsage";
import {getDecoctionName, refreshDecoctionNameMap} from "@/assets/utils/decoction";

/**
 * pending 自动轮询窗口（秒）。与后端扫码支付锁的 TTL 对齐
 * （ISqbOrderPayServiceImpl.SCAN_PAY_LOCK_MINUTES = 10 分钟）：
 * 窗口不得大于锁的 TTL —— 窗口先到点而锁还在，会出现「页面已转待人工核查、
 * 收银员想重扫却被锁挡住」的自相矛盾状态。两处必须一起改。
 */
const PAY_PENDING_WINDOW_SECONDS = 600;
/** pending 期间两次查单之间的间隔（秒） */
const PAY_PENDING_POLL_INTERVAL_SECONDS = 10;

export default {
    props: {
        orderId: ""
    },
    data() {
        return {
            userInfo: null,
            headImg: "",
            sysName: "",
            medicalOrder: {
                dppId: null, // 关联的病例ID
                docId: null, // 关联的医生ID
                docPatientCaseId: null, // 关联的病历ID
                conId: null,
                serialNo: null,
                docPrice: "0.00", //诊费
                clinicalDiagnosis: null, // 诊断结果
                medicineType: "0", //药剂类型
                billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
                orderMedicineList: [], // 关联药品
                remark: null, //备注
                patientPhone: null,
                patientName: null, // 患者姓名
                patientSex: null, // 患者性别
                patientAge: null,  // 患者年龄
                patientIdentity: null, // 患者身份证
                oldOrderId: null,
                linkDoctorInfo: null,
                hasLinkDoctor: false,
                takeWay: "0",
                viceNum: "7", //药品副数
                // docAdvice: '每日一副 分两次服用（开水冲化 温服）',  //医嘱
                docAdvice: '开水温服',
                orderWeight: "0", // 药材总重
                medicalCountPrice: "0.00", //药材费用
                processingCosts: "0.00", //加工费用
                orderPrice: "0.00", //总价
                instructions: null,
                smsPhone: "",
                adjustmentPrice: "0.00",// 调理价格
                discountPrice: "0.00", // 优惠金额
                freeCasePic: "", // 科研药方的图片
                isFree: "1",
                dayTakeNum: "1", //X日一剂
                takeTimes: "2", // 每日分X次服用/每日X次
                timeUseNum: "1", // 每次XX克、XX毫升
                packWay: "0", // 包装方式 （0袋装 1瓶装）
                useWay: null, // 医嘱用法
                useAttention: null, // 医嘱禁忌
                fuCountPrice: 0,  // 辅药药品费用
                decoctType: '0', // 煎煮方式  0=自煎,1=代煎
                specification: '200', // 煎煮规格 规格 200ml/100ml
                orderMedicineFuList: [],  //辅药列表（和药品列表一样传参）
                completeTime: "",
                cancelTime: "",
                payTime: "",
                deliverWay: '1', // 配送方式
                receivePersonName: "", // 收货人姓名
                receivePhone: "", // 收货人手机
                receiveProvince: "", // 收货人所在省
                receiveCity: "", // 收货人所在市
                receiveCountry: "", // 收货人所在区
                receiveAddress: "", // 收货详细地址
            },
            doctorInfo: {
                docPrice: null,
                docPriceRate: null,
                docPriceWay: 0,
                docFreeOpen: ""
            },
            dictOrderStatus: 'sys_order_status',
            dictOrderStatusList: [],

            prescriptionPaperDialogDialogVisible: false, // 处方笺预览弹窗
            printDate: null, // 打印日期
            payCodeList: [], // 预览的支付码
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            showOrderMedicineFuList: "",
            detailLoading: false,

            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部处方笺', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部处方笺', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: true, // 订单收费等待扫码
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            payErrorMsg: "", // 支付失败错误信息（后端返回）
            payState: "", // 支付结果三态：success / pending / failed
            payChannel: "", // 支付成功渠道：SQB / CASH / FREE
            payRequesting: false, // 支付请求进行中，防止重复扫码发起第二笔扣款
            querying: false, // 「重新查询」进行中
            payPendingTimer: null, // pending 自动轮询定时器（1 秒 tick，同时驱动倒计时）
            payPendingRemain: 0, // pending 窗口剩余秒数
            payPendingExpired: false, // pending 窗口是否已到点（转「待人工核查」）
            removeScanListener: null, // 用于存储移除扫码监听器的函数
            newRuleOpen: false, // 新规则开关（按比例换算剂量）
            decoctionNameMap: {}
        }
    },

    created() {
        getDicts(this.dictOrderStatus).then(res => {
            this.dictOrderStatusList = res.data.data;
        });

        refreshDecoctionNameMap().then(map => {
            this.decoctionNameMap = map;
        }).finally(() => this.getMedicalOrderDetailInfo());

    },
    mounted() {
        let newRuleOpen = window.sessionStorage.getItem('newRuleOpen');
        console.log("newRuleOpen >>>>> " + newRuleOpen);
        this.newRuleOpen = newRuleOpen === 'true';
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
            this.medicalOrder.docId = this.doctorInfo.doctorId;
            if (this.doctorInfo.docPrice === null || this.doctorInfo.docPrice === undefined || this.doctorInfo.docPrice === '') {
                this.doctorInfo.docPrice = "0";
            }
            if (this.doctorInfo.docPriceRate === null || this.doctorInfo.docPriceRate === undefined || this.doctorInfo.docPriceRate === '') {
                this.doctorInfo.docPriceRate = "0";
            }
        }
        this.initScanListener();
    },
    // 在 beforeUnmount 钩子中清理事件监听器（Vue 3 中 beforeDestroy 不会触发）
    beforeUnmount() {
        // 如果存在移除监听器的函数，则调用它
        this.stopPayPendingWatch();
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    computed: {
        // 三态文案：pending 绝不能被渲染成失败，否则会诱导收费员重复扫码
        payResultText() {
            if (this.payState === 'success') {
                return '已支付成功';
            }
            if (this.payState === 'pending') {
                // 窗口到点后转「待人工核查」：仍是「未确认」，绝不能说成失败
                return this.payPendingExpired ? '待人工核查' : '支付结果确认中';
            }
            return '支付失败';
        }
    },
    methods: {
        // 药方总重统一按处方展示克重 newGCount 累加，避免与药材明细不一致。
        getOrderWeightByNewGCount(medicineList) {
            if (!Array.isArray(medicineList)) {
                return '0.00';
            }
            const totalWeight = medicineList.reduce((total, item) => {
                const weight = parseFloat(item.newGCount);
                return total + (Number.isNaN(weight) ? 0 : weight);
            }, 0);
            return totalWeight.toFixed(2);
        },

        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            // AC12：请求未返回前不允许再次扫码，否则并发扫码会发起第二笔扣款
            if (this.payRequesting) {
                console.warn("上一笔支付请求尚未返回，忽略本次扫码");
                return;
            }
            console.log("orderId >>>>" + this.medicalOrder.orderId);
            console.log("orderPrice >>>>" + this.medicalOrder.orderPrice);
            console.log("dynamicId >>>>" + dynamicId);
            this.payRequesting = true;
            // 新一次扫码：结束上一轮 pending 窗口
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
            this.payLoading = true;
            this.isPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            let params = {
                orderId: this.medicalOrder.orderId,
                price: this.medicalOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            clinicSqbOrderPay(JSON.stringify(params)).then(response => {
                console.log(response);
                this.isWaitPayLoading = false;
                this.payLoading = false;
                this.isPayed = true;
                this.applyPayResult(response, false);
            }).catch(error => {
                // AC13：请求异常一律回到「可重试」态，不能停留在等待扫码
                console.error('支付请求失败:', error);
                message("支付请求失败", "error");
                this.payLoading = false;
                this.isWaitPayLoading = true;
                this.isPayed = false;
                this.payState = "";
                this.payChannel = "";
            }).finally(() => {
                this.payRequesting = false;
            });
        },

        // 统一落地后端三态契约：200+success / 601+pending / 其他=明确失败
        applyPayResult(response, silent) {
            const data = (response && response.data) || {};
            const payState = data.payState;
            const channel = data.channel;
            if (response && response.code === 200 && payState === 'success') {
                this.payState = 'success';
                this.payChannel = channel || '';
                this.successPayed = true;
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payErrorMsg = "";
                message(this.paySuccessText(channel), "success");
                this.getMedicalOrderDetailInfo();
            } else if (response && response.code === 601 && payState === 'pending') {
                // AC3：第三态。既不得显示成功，也不得显示失败。
                this.payState = 'pending';
                this.payChannel = "";
                this.successPayed = false;
                if (!this.payPendingTimer && !this.payPendingExpired) {
                    // 首次进入 pending：开自动轮询窗口（与后端支付锁 TTL 对齐）
                    this.startPayPendingWatch();
                }
                this.payErrorMsg = this.payPendingExpired
                    ? this.pendingExpiredMessage()
                    : this.pendingMessage();
                if (!silent) {
                    message("支付结果确认中，请勿重复扫码", "warning");
                }
            } else {
                this.payState = 'failed';
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payChannel = '';
                this.successPayed = false;
                this.payErrorMsg = (response && response.msg) || "支付失败";
                message(this.payErrorMsg, "error");
            }
        },

        paySuccessText(channel) {
            if (channel === 'CASH') {
                return "该订单已现金收款";
            }
            if (channel === 'FREE') {
                return "该订单为免费单，无需支付";
            }
            return "支付成功";
        },

        // AC3：pending 态的「重新查询」，只读接口，绝不发起扣款
        requeryPayResult(silent) {
            if (this.querying) {
                return;
            }
            this.querying = true;
            clinicSqbQueryResult(this.medicalOrder.orderId).then(response => {
                this.isWaitPayLoading = false;
                this.payLoading = false;
                this.isPayed = true;
                this.applyPayResult(response, silent);
            }).catch(error => {
                console.error('查询支付结果失败:', error);
                if (!silent) {
                    message("查询支付结果失败，请稍后重试", "error");
                }
            }).finally(() => {
                this.querying = false;
            });
        },

        /**
         * 开始 pending 自动轮询：每 PAY_PENDING_POLL_INTERVAL_SECONDS 秒查一次只读查单接口，
         * 最长 PAY_PENDING_WINDOW_SECONDS 秒；到点转「待人工核查」。
         *
         * 窗口到点后支付锁也随之过期，收银员可重新扫码 —— 重扫会先经后端
         * checkPreviousScanOrder：上一笔已 PAID 则直接报成功，仍是未定态则被保守拦截，
         * 因此「放行重扫」不会造成重复扣款。
         */
        startPayPendingWatch() {
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = PAY_PENDING_WINDOW_SECONDS;
            this.payPendingTimer = setInterval(() => {
                // 状态已被其他路径改写（成功/失败/重置）时窗口自行结束，
                // 这样各处的重置逻辑不必逐个记得清定时器
                if (this.payState !== 'pending') {
                    this.stopPayPendingWatch();
                    return;
                }
                this.payPendingRemain -= 1;
                if (this.payPendingRemain <= 0) {
                    this.stopPayPendingWatch();
                    this.markPayPendingExpired();
                    return;
                }
                this.payErrorMsg = this.pendingMessage();
                if (this.payPendingRemain % PAY_PENDING_POLL_INTERVAL_SECONDS === 0) {
                    // 自动轮询不弹 toast，避免每 10 秒打扰收银员一次
                    this.requeryPayResult(true);
                }
            }, 1000);
        },

        stopPayPendingWatch() {
            if (this.payPendingTimer) {
                clearInterval(this.payPendingTimer);
                this.payPendingTimer = null;
            }
        },

        // 窗口到点：转「待人工核查」。绝不能说成「支付失败」—— 钱可能已经收了。
        markPayPendingExpired() {
            this.payPendingExpired = true;
            this.payErrorMsg = this.pendingExpiredMessage();
            message(this.payErrorMsg, "warning");
        },

        pendingMessage() {
            return "支付结果确认中，请勿重复扫码（自动查询中，剩余 " + this.payPendingRemain + " 秒）";
        },

        pendingExpiredMessage() {
            return "支付结果超过 " + (PAY_PENDING_WINDOW_SECONDS / 60) + " 分钟仍未确认，请人工核查收钱吧流水";
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },


        getOrderStatus(dictCode) {
            return this.getDictValue(dictCode, this.dictOrderStatusList);
        },

        getDictValue(dictKey, dictList) {
            let str = '';
            dictList.forEach(e => {
                if (e.dictValue == dictKey) {
                    str = e.dictLabel;
                }
            })
            return str;
        },

        // 获取订单详情信新
        getMedicalOrderDetailInfo() {
            console.log(this.orderId);
            this.detailLoading = true;
            getMedicalOrderDetail(this.orderId).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    this.detailLoading = false;
                    this.patientInfo = response.data.data.patientInfo;
                    if (this.patientInfo.sex === "1") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                    } else if (this.patientInfo.sex === "0") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                    } else {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                    }
                    this.medicalOrder = response.data.data.medicalOrder;
                    if (this.medicalOrder.docAdvice === null) {
                        this.medicalOrder.docAdvice = '每日一副 分两次服用（开水冲化 温服）';
                    }
                    if (this.medicalOrder.picUrl !== null && this.medicalOrder.picUrl !== "") {
                        this.medicalOrder.picUrl = this.tencentCosUrl + this.medicalOrder.picUrl;
                    }
                    this.payCodeList = [];
                    this.payCodeList.push(this.tencentCosUrl+this.medicalOrder.payQrcode);
                    if (this.medicalOrder.takeWay === "null" || this.medicalOrder.takeWay === null) {
                        this.medicalOrder.takeWay = "0";
                    }
                    if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === undefined || this
                        .medicalOrder.viceNum === "") {
                        this.medicalOrder.viceNum = "1";
                    }
                    this.indexMedicine = this.medicalOrder.billingType === null ? '0' : this.medicalOrder.billingType;
                    this.indexeat = parseInt(this.medicalOrder.takeWay === null ? '0' : this.medicalOrder.takeWay);
                    this.indexSex = parseInt(this.medicalOrder.patientSex === null ? '0' : this.medicalOrder.patientSex);

                    this.medicalOrder.packWay = this.medicalOrder.packWay === null ? '0' : this.medicalOrder.packWay;

                    this.medicalOrder.dayTakeNum = this.medicalOrder.dayTakeNum === null ? '1' : this.medicalOrder.dayTakeNum;//X日一剂
                    this.medicalOrder.takeTimes = this.medicalOrder.takeTimes === null ? '2' : this.medicalOrder.takeTimes;// 每日分X次服用/每日X次
                    this.medicalOrder.timeUseNum = this.medicalOrder.timeUseNum === null ? '1' : this.medicalOrder.timeUseNum;// 每次XX克、XX毫升

                    this.docMedicineArray = [];
                    var orderMedicineList = this.medicalOrder.orderMedicineList;
                    console.log("orderMedicineList");
                    console.log(orderMedicineList);
                    if (orderMedicineList !== null) {
                        orderMedicineList.forEach(melist => {
                            let decoctWay = melist.decoctWay;
                            let decoctionName = getDecoctionName(decoctWay, this.decoctionNameMap);
                            melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            if (this.medicalOrder.billingType === "0") {
                                if (melist.newGCount === null) {
                                    melist.newGCount = melist.countNum;
                                }
                                if (melist.newRatio === null) {
                                    melist.newRatio = 1;
                                }
                                if (this.newRuleOpen) {
                                    melist.countNum = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                                } else {
                                    melist.countNum = melist.newGCount;
                                }
                            } else {
                                melist.newGCount = melist.countNum;
                            }
                            if (melist.meStatus === null || melist.meStatus === "" || melist.meStatus === undefined) {
                                melist.meStatus = "0";
                            }
                            this.docMedicineArray.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                price: melist.medicinePrice,
                                gCount: melist.countNum,
                                newGCount: melist.newGCount,
                                newRatio: melist.newRatio,
                                standard: melist.standard,
                                meRemark: melist.meDesc,
                                mCount: melist.totalPrice,
                                decoctionId: decoctWay,
                                decoctionName: decoctionName,
                                drugProperty: melist.drugProperty,
                                meStatus: melist.meStatus,
                                isLimitUsage: melist.isLimitUsage,
                                limitThreshold: melist.limitThreshold
                            });
                        })
                    }

                    this.chooseFuliaoList = [];
                    var orderMedicineFuList = this.medicalOrder.orderMedicineFuList;
                    console.log("orderMedicineFuList");
                    console.log(orderMedicineFuList);
                    if (orderMedicineFuList !== null) {
                        orderMedicineFuList.forEach(melist => {
                            this.chooseFuliaoList.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                meDesc: melist.meDesc,
                                price: melist.price,
                                meCount: melist.countNum,
                                countPrice: melist.totalPrice
                            });
                        })
                    }

                    if (this.docMedicineArray.length > 0) {
                        this.docMedicineArray.forEach(docMedlist => {
                            docMedlist.decoctWay = docMedlist.decoctionId;
                        });
                        this.medicalOrder.orderMedicineList = this.docMedicineArray;

                        // // ===== 临时模拟超量数据（用于核验超量签章展示效果，核验后删除本段） =====
                        // if (this.docMedicineArray[0]) {
                        //     this.docMedicineArray[0].isLimitUsage = '1';
                        //     this.docMedicineArray[0].limitThreshold = 5;
                        // }
                        // // ===== 临时模拟结束 =====

                        this.refreshUsageSigns();// 刷新超量签章信息
                    }
                    // this.reCount();
                } else {
                    message(response.data.msg, 'error');
                }
            });

        },


        // 统一刷新药材超量签章信息（根据实际重量与限制阈值对比）
        refreshUsageSigns() {
            const doctorName = getSignDoctorName();
            this.docMedicineArray.forEach(item => updateMedicineUsageSign(item, doctorName));
        },

        // 打开处方笺
        exportOrder() {
            this.prescriptionPaperDialogDialogVisible = true;
            this.printDate = this.getDayDateNow();
        },



        // 订单收费
        openPayScreen() {
            this.orderPayDialogVisible = true;
            this.payState = "";
            this.payChannel = "";
            this.getMedicalOrderDetailInfo();
        },


        // 支付失败刷新重试
        cancalOrRefreshPay() {
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
            this.getMedicalOrderDetailInfo();
        },


        // 打印待支付单据
        printPayInfo() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
        },


        // 取消支付
        cancalPay() {
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
        },



        // 取消订单
        userCancelOrder() {
            this.$confirm('确定要取消/作废当前订单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                cancelOrder(this.orderId).then(response => {
                    if (response.data.code === 200) {
                        message("订单取消成功！", "success");
                        this.getMedicalOrderDetailInfo();
                        let navselected = this.$store.state.adminleftnavnum;
                        if (navselected === 'clinictreat') {
                            this.$emit('orderDetailStatus', false);
                        }
                    } else {
                        message("订单取消失败！", "error");
                    }
                })
            }).catch(() => {
                console.log('用户取消操作');
            })

        },



        // 修改订单
        userEditOrder() {
            this.$confirm('确定要修改当前订单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.removeItem('choosePreId');
                window.sessionStorage.removeItem("conId");
                let navselected = this.$store.state.adminleftnavnum;
                console.log(navselected);
                if (navselected !== 'clinictreat') {
                    this.$router.push({path: '/admin/clinictreat', query: { qorderId: this.orderId, qeditOrder: '0' }});
                    this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
                } else {
                    window.sessionStorage.removeItem('orderId');
                    window.sessionStorage.removeItem('again');
                    window.sessionStorage.removeItem('editOrder');
                    window.sessionStorage.setItem("orderId", this.orderId);
                    window.sessionStorage.setItem("editOrder", "0");
                    this.$emit('orderDetailStatus', false);
                }
            }).catch(() => {
                console.log('用户取消操作');
            })
        },

        // 再来一单
        oneMoreOrder() {
            this.$confirm('确定依据当前订单信息再次下单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.removeItem('choosePreId');
                window.sessionStorage.removeItem("conId");
                let navselected = this.$store.state.adminleftnavnum;
                console.log(navselected);
                if (navselected !== 'clinictreat') {
                    this.$router.push({path: '/admin/clinictreat', query: { qorderId: this.orderId, qagain: '0' }});
                    this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
                } else {
                    window.sessionStorage.removeItem('orderId');
                    window.sessionStorage.removeItem('again');
                    window.sessionStorage.removeItem('editOrder');
                    window.sessionStorage.setItem("orderId", this.orderId);
                    window.sessionStorage.setItem("again", "0");
                    this.$emit('orderDetailStatus', false);
                }
            }).catch(() => {
                console.log('用户取消操作');
            })
        },



        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
